export default "__VITE_ASSET__ChuLAeua__"